import orderBy from "lodash/orderBy";
import first from "lodash/first";
import find from "lodash/find";
import get from "lodash/get";
import mean from "lodash/mean";
import Bugsnag from "@bugsnag/js";

// Get real price, or rough price value
const getProductPrice = (product, country) => {
  let price = get(product, `prices.${country}.PRICE`);
  if (!price) price = get(product, `prices.${country}.VALUE`);
  return price;
};

// Sort products by highest allSpecValue * productValue, and then by budgetWeighting
const sortProducts = (products) => {
  products = products.map((product) => {
    const subTotalValue = product.allSpecValue * product.productValue;

    // Now by contractWeighting...
    let totalValue = subTotalValue * product.contractWeighting;

    // Now by budgetWeighting...
    totalValue = totalValue * product.budgetWeighting;

    return { ...product, subTotalValue, totalValue };
  });

  return orderBy(products, "totalValue", "desc");
};

// No Best Choice product found, fire an error and return early
const resultsError = (products, state) => {
  Bugsnag.notify(
    new Error(`${state.quiz.name} returned no Best Choice option`),
    { products, state }
  );

  return [null, null, null];
};

// Result Relevances from product
const getResultRelevances = (products) => {
  return products.reduce((acc, product) => {
    if (!product) return acc;

    const relevances = product.relevance.map((r) => r.text);
    return { ...acc, [product.id]: relevances };
  }, {});
};

const getFinalResults = (products, state) => {
  products = sortProducts(products);

  // console.log(products);
  // debugger;

  // Bugsnag.notify(new Error("Output of the Quiz Results"), {
  //   metaData: {
  //     state,
  //     products
  //   },
  //   severity: "info"
  // });

  // Best Choice - First product from the sorted Array
  const bestChoice = first(products);

  if (!bestChoice) return resultsError(products, state);

  // Store Best Choice's price, for later use
  const bestChoicePrice = getProductPrice(bestChoice, state.country);

  // Upgrade & Budget are determined from what's left over
  let remainder = products.filter((p) => p.id !== bestChoice.id);
  remainder = orderBy(remainder, "subTotalValue", "desc");

  // Get the budget slider answer
  const usersBudget = getUsersBudgetValue(state.answers);

  // Upgrade Option - Highest subTotalValue, with a higher price than Best Choice
  const upgradeOption = find(remainder, (product) => {
    // If the product has less than 50% of the Best Choices allSpecValue, skip
    if (product.allSpecValue < bestChoice.allSpecValue * 0.5) return false;

    const productPrice = getProductPrice(product, state.country);

    // Upgrade can only be twice the user's budget
    if (usersBudget > 0) {
      return productPrice > bestChoicePrice && productPrice < usersBudget * 2;
    }

    return productPrice > bestChoicePrice;
  });

  // Budget Option - Highest subTotalValue, with a lower price than Best Choice
  const budgetOption = find(remainder, (product) => {
    // If the product has less than 50% of the Best Choices allSpecValue, skip
    if (product.allSpecValue < bestChoice.allSpecValue * 0.5) return false;

    const productPrice = getProductPrice(product, state.country);
    return productPrice < bestChoicePrice;
  });

  // Grab Object of relevances for each chosen product
  const relevances = getResultRelevances([
    bestChoice,
    upgradeOption,
    budgetOption,
  ]);

  // Return just IDs
  return [
    bestChoice.id,
    get(upgradeOption, "id", null),
    get(budgetOption, "id", null),
    relevances,
  ];
};

export default getFinalResults;

function getUsersBudgetValue(answers) {
  const values = answers.reduce((acc, curr) => {
    const budgetAnswer = curr.answer.find((a) => a.type === "budget");
    if (budgetAnswer) return [...acc, budgetAnswer.value];
    return acc;
  }, []);

  return !values.length ? 0 : mean(values);
}
